import { PageModule } from '@abp/ng.components/page';
import { CoreModule, ListService } from '@abp/ng.core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  } from '@ng-bootstrap/ng-bootstrap';
import { ImageLightboxComponent } from 'src/app/shared/image-lightbox/image-lightbox.component';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@shared/commercial-ui';
import { AbstractPaymentHistoryComponent } from './payment-history.abstract.component';
import { PaymentHistoryViewService } from 'src/app/payments/services/payment-history.service';
import { formatDateTime } from 'src/app/shared/utils/dateUtils';

@Component({
    selector: 'app-payment-history',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.scss'],
    imports: [
        NgbCollapseModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        ImageLightboxComponent,
        PageModule,
        CoreModule,
        ThemeSharedModule,
        CommercialUiModule,
    ],
    providers: [ListService, PaymentHistoryViewService]
})
export class PaymentHistoryComponent extends AbstractPaymentHistoryComponent {
  title = '::PaymentHistoryTitle';
  isLoading = true;

  formatDateTime = (dateString:string)=> formatDateTime(new Date(dateString));

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
  }
